import { BASE_PURCHASE_SUBSCRIPTION_SETTINGS_PATH } from "common/constants";
import React from "react";
import Banner from "common/Banner/Banner";
import { AuthUser } from "@shared/types";
import { useRestrictedCountriesPurchase } from "utils/hooks/misc";
import Button from "common/Buttons/Button";
import styled, { useTheme } from "styled-components";
import { hexToRGB } from "@shared/utils/misc";
import IntercomLink from "common/Text/IntercomLink";

interface SubscriptionExpiredBannerProps {
  user: AuthUser;
}

const SubscriptionExpiredBanner = ({
  user,
}: SubscriptionExpiredBannerProps) => {
  const theme = useTheme();
  const { onPurchaseClick } = useRestrictedCountriesPurchase();

  if (!user.isExpired()) return null;

  return (
    <Banner color={theme.colors.secondaryRed}>
      Your subscription has expired - Renew now{" "}
      {user?.in_view_only_grace_period
        ? "to prevent interruptions in your service"
        : "to continue using Cornix"}
      .
      <RenewButton
        onClick={() =>
          onPurchaseClick(BASE_PURCHASE_SUBSCRIPTION_SETTINGS_PATH)
        }
        style={{ marginLeft: 12, marginRight: 12 }}
      >
        Renew
      </RenewButton>
      <StyledLink articleId="5814831">Read More</StyledLink>
    </Banner>
  );
};

export default SubscriptionExpiredBanner;

const RenewButton = styled(Button).attrs({ $type: "outlined" })`
  color: ${(p) => p.theme.colors.secondaryRed} !important;
  border-color: ${(p) => p.theme.colors.secondaryRed} !important;
  &:hover {
    border-color: ${(p) => p.theme.colors.secondaryRed};
  }
`;
const StyledLink = styled(IntercomLink)`
  color: ${(p) => p.theme.colors.secondaryRed};
  &:hover {
    color: ${(p) => hexToRGB(p.theme.colors.secondaryRed, 0.7)};
  }
`;
